export enum ParameterCategory {
    Hematology = "hematology",
    LiverAndBiliaryTract = "liver_and_biliary_tract",
    Kidneys = "kidneys",
    Electrolytes = "electrolytes",
    Lipids = "lipids",
    GlucoseMetabolismAndInsulinResistance = "glucose_metabolism_and_insulin_resistance",
    ThyroidProfile = "thyroid_profile",
    ObesityRelatedMetainflammation = "obesity_related_metainflammation",
    Pancreas = "pancreas",
    MusclesAndTissues = "muscles_and_tissues",
    Prostate = "prostate",
    WomanOver40 = "woman_over_40",
    UrineTest = "urine_test",
    BloodInTheStool = "blood_in_the_stool",
}

export enum ParameterSubCategory {
    Hemocrome = "hemocrome",
    ElectrophoreticProteinFramework = "electrophoretic_protein_framework",
    BilirubinaReflex = "bilirubina_reflex",
    PartialThromboplastinTime = "partial_thromboplastin_time",
    UrineTest = "urine_test",
    Other = "other",
}

export const CATEGORY_TO_SUBCATEGORIES: Record<ParameterCategory, ParameterSubCategory[]> = {
    [ParameterCategory.Hematology]: [ParameterSubCategory.Hemocrome, ParameterSubCategory.ElectrophoreticProteinFramework],
    [ParameterCategory.LiverAndBiliaryTract]: [ParameterSubCategory.BilirubinaReflex, ParameterSubCategory.Other],
    [ParameterCategory.Kidneys]: [ParameterSubCategory.Other],
    [ParameterCategory.Electrolytes]: [ParameterSubCategory.Other],
    [ParameterCategory.Lipids]: [ParameterSubCategory.Other],
    [ParameterCategory.GlucoseMetabolismAndInsulinResistance]: [ParameterSubCategory.Other],
    [ParameterCategory.ThyroidProfile]: [ParameterSubCategory.Other],
    [ParameterCategory.ObesityRelatedMetainflammation]: [ParameterSubCategory.Other],
    [ParameterCategory.Pancreas]: [ParameterSubCategory.Other],
    [ParameterCategory.MusclesAndTissues]: [ParameterSubCategory.Other],
    [ParameterCategory.Prostate]: [ParameterSubCategory.Other],
    [ParameterCategory.WomanOver40]: [ParameterSubCategory.PartialThromboplastinTime, ParameterSubCategory.Other],
    [ParameterCategory.UrineTest]: [ParameterSubCategory.UrineTest],
    [ParameterCategory.BloodInTheStool]: [ParameterSubCategory.Other]
}

export const CATEGORY_LABELS_IT: Record<string, string> = {
    [ParameterCategory.Hematology]: "Ematologia",
    [ParameterCategory.LiverAndBiliaryTract]: "Fegato e vie biliari",
    [ParameterCategory.Kidneys]: "Reni",
    [ParameterCategory.Electrolytes]: "Elettroliti",
    [ParameterCategory.Lipids]: "Quadro lipidico",
    [ParameterCategory.GlucoseMetabolismAndInsulinResistance]: "Metabolismo glucidico e insulino-resistenza",
    [ParameterCategory.ThyroidProfile]: "Profilo tiroideo",
    [ParameterCategory.ObesityRelatedMetainflammation]: "Markers di metainfiammazione obesità-correlata",
    [ParameterCategory.Pancreas]: "Pancreas",
    [ParameterCategory.MusclesAndTissues]: "Muscolatura e tessuti",
    [ParameterCategory.Prostate]: "Prostata",
    [ParameterCategory.WomanOver40]: "Donna over 40",
    [ParameterCategory.UrineTest]: "Esame urine",
    [ParameterCategory.BloodInTheStool]: "Sangue nelle feci",
};

export const SUBCATEGORY_LABELS_IT: Record<string, string> = {
    [ParameterSubCategory.Hemocrome]: "Emocromo",
    [ParameterSubCategory.ElectrophoreticProteinFramework]: "Quadro proteico elettroforetico",
    [ParameterSubCategory.BilirubinaReflex]: "Bilirubina Reflex",
    [ParameterSubCategory.PartialThromboplastinTime]: "Tempo di tromboplastina parziale",
    [ParameterSubCategory.UrineTest]: "Esame urine",
    [ParameterSubCategory.Other]: "Altra",
};
